const getters = {
  getShowRedirectToPaymentModal: state => state.showRedirectToPaymentModal,
  getShowRedirectToLastRouteModal: state => state.showRedirectToLastRouteModal,
  getPlans: state => state.plans,
  getPlansLoading: state => state.plansLoading,
  getCurrentPlan: state => state.currentPlan,
  isFreePlan: state => state.currentPlan && state.currentPlan?.planTier === 'free',
  getPromoCampaignData: state => state.promoCampaign,
}

export default getters
